import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { logoutRoutine } from '../../../redux/routines';

class Logout extends Component {
  static propTypes = {
    // history: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
  };

  componentWillMount() {
    this.props.logout();
  }

  render() {
    return (
      <div>
        Logging out...
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    logout: () => logoutRoutine.trigger({ redirect: true }),
  }, dispatch);
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Logout);



// WEBPACK FOOTER //
// ./src/components/Authentication/Logout/index.js